import { render, staticRenderFns } from "./SurveyCreation.vue?vue&type=template&id=e1316022&scoped=true&"
import script from "./SurveyCreation.vue?vue&type=script&lang=js&"
export * from "./SurveyCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1316022",
  null
  
)

export default component.exports